import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { accountFeatureKey } from '../tokens';
import { AccountEffects } from './account.effects';
import { AccountConfigToken, accountReducer } from './account.state';

@NgModule({
  imports: [
    StoreModule.forFeature(accountFeatureKey, accountReducer, AccountConfigToken),
    EffectsModule.forFeature([AccountEffects]),
  ],
})
export class AccountStoreModule {}
